const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const getContactUsApi = async (page = 1, perPage = 15) => {
    const token = localStorage.getItem('token');
    const url = `${API_BASE_URL}/admin/lead/contact-us?page=${page}&per_page=${perPage}`;

    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData?.message || 'Ошибка при получении запросов Contact Us');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Ошибка API Contact Us:', error);
        throw error;
    }
};